import { Route } from '@angular/router';
import { LayoutComponent } from '@zopup/zop-ux-layout';
// import { PackageListComponent } from './@zop-ux-subscription';

import { initialDataResolver } from './app.resolvers';
import { AuthGuard, NoAuthGuard, NoAuthChildGuard } from '@zopup/zop-auth';

export const appRoutes: Route[] = [
    // Redirect empty path to '/dashboards/project'
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'masters/categories',
    },

    // Auth routes for guests
    {
        path: '',
        canActivateChild: [NoAuthChildGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadComponent: () =>
                    import('@zopup/zop-auth').then(
                        (m) => m.AuthConfirmationRequiredComponent
                    ),
            },
            {
                path: 'forgot-password',
                loadComponent: () =>
                    import('@zopup/zop-auth').then(
                        (m) => m.AuthForgotPasswordComponent
                    ),
            },
            {
                path: 'reset-password',
                loadComponent: () =>
                    import('@zopup/zop-auth').then(
                        (m) => m.AuthResetPasswordComponent
                    ),
            },
            {
                path: 'sign-in',
                loadComponent: () =>
                    import('@zopup/zop-auth').then(
                        (m) => m.AuthSignInComponent
                    ),
            },
            {
                path: 'sign-up',
                loadComponent: () =>
                    import('@zopup/zop-auth').then(
                        (m) => m.AuthSignUpComponent
                    ),
            },
            {
                path: 'tenant-selection',
                loadComponent: () =>
                    import('@zopup/zop-auth').then(
                        (m) => m.TenantSelectionComponent
                    ),
            },
        ],
    },

    // Masters
    {
        path: 'masters',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            // brands
            {
                path: 'brands',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-brand').then(
                                (m) => m.zopUxBrandsRoutes
                            ),
                    },
                ],
            },

            // attributes
            {
                path: 'attributes',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-catalogue').then(
                                (m) => m.zopUxAttributeMasterRoutes
                            ),
                    },
                ],
            },

            //Business Types
            {
                path: 'business-types',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-tax').then(
                                (m) => m.zopUxBusinessTypesRoutes
                            ),
                    },
                ],
            },

            //Statutory Masters
            {
                path: 'statutory-master',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-tax').then(
                                (m) => m.zopUxStatutoryMasterRoutes
                            ),
                    },
                ],
            },

            //Tax Masters
            {
                path: 'tax-master',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-tax').then(
                                (m) => m.zopUxTaxMasterRoutes
                            ),
                    },
                ],
            },

            {
                path: 'currencies',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-currencies').then(
                                (m) => m.zopUxCurrenciesRoutes
                            ),
                    },
                ],
            },

            // Categories
            {
                path: 'categories',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-categories').then(
                                (m) => m.zopUxCategoriesRoutes
                            ),
                    },
                ],
            },

            //Financial Year
            {
                path: 'financial-year',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-ux-finance').then(
                                (m) => m.zopUxFinancialYearsRoutes
                            ),
                    },
                ],
            },

            // Manufacturers
            {
                path: 'manufacturers',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('@zopup/zop-manufacturer').then(
                                (m) => m.zopUxManufacturersRoutes
                            ),
                    },
                ],
            },

            // Product catalogue
            {
                path: 'catalogue',
                loadChildren: () =>
                    import('@zopup/zop-ux-catalogue').then(
                        (m) => m.zopUxCatalogueRoutes
                    ),
            },
        ],
    },

    {
        path: 'tenant-management',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            // Subscriptions Packages
            {
                path: 'subscription-packages',
                loadChildren: () =>
                    import('@zopup/zop-ux-subscriptions').then(
                        (m) => m.zopUxPackageRoutes
                    ),
            },
            // Tenants
            {
                path: 'tenants',
                loadChildren: () =>
                    import('@zopup/zop-ux-subscriptions').then(
                        (m) => m.zopUxTenantsRoutes
                    ),
            },
            // Tenants
            // {
            //     path: 'tenants',
            //     children: [
            //         {
            //             path: '',
            //             // loadComponent: () =>
            //             // import('@zopup/zop-ux-subscriptions').then(
            //             //     (m) => m.TenantListComponent
            //             // ),
            //             loadChildren: () =>
            //                 import('@zopup/zop-ux-subscriptions').then(
            //                     (m) => m.zopUxTenantsRoutes
            //                 ),
            //         },
            //     ],
            // },

            // Audit log
            {
                path: 'audit-log',
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('@zopup/zop-ux-audit').then(
                                (m) => m.AuditLogListComponent
                            ),
                    },
                ],
            }
        ],
    },
];
